import React, { useMemo, useRef, useState } from 'react';
import { Platform, Pressable, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

// Presentation only: each platform retains its own message, service and action
// owner. Both desktop clients use the same card frame and expansion affordance.
export default function ResponseCardFrame({ colors, modelHeader, expanded, streaming, onToggle, label, children, enableFocusRing }) {
  const [hovered, setHovered] = useState(false);
  const header = useRef(null);
  function toggle(event) {
    if (streaming || !onToggle) return;
    // Match Windows buttons: a pointer expansion must take keyboard focus
    // away from the composer before a subsequent Enter can send its draft.
    if (Platform.OS === 'windows') header.current?.focus?.();
    onToggle(event);
  }
  const styles = useMemo(() => StyleSheet.create({
    frame: { borderRadius: 12, borderWidth: 1, borderColor: colors.border_color_secondary, backgroundColor: colors.solid_color_primary, overflow: 'hidden', ...(Platform.OS === 'web' ? { transition: 'all 0.2s ease' } : {}) },
    header: { flexDirection: 'row', alignItems: 'center', paddingVertical: 10, paddingHorizontal: 12, minHeight: 48, gap: 10 },
    toggle: { paddingVertical: 4, paddingHorizontal: 8, borderRadius: 6, backgroundColor: colors.solid_color_secondary, flexDirection: 'row', alignItems: 'center', gap: 4, flexShrink: 0 },
  }), [colors]);
  const Header = onToggle ? Pressable : View;
  return <View style={[styles.frame, hovered && { borderColor: colors.border_color_input }]} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
    <Header ref={onToggle ? header : undefined} style={onToggle ? ({ pressed }) => [styles.header, pressed && { opacity: 0.8 }] : styles.header} onPress={onToggle ? toggle : undefined} disabled={streaming}
      {...(Platform.OS === 'windows' ? { enableFocusRing } : {})}
      accessibilityRole={onToggle ? 'button' : undefined} accessibilityLabel={label || (expanded ? 'Collapse response' : 'Expand response')} accessibilityState={onToggle ? { expanded: !!expanded, disabled: !!streaming } : undefined}>
      {modelHeader}
      {!!(streaming || onToggle) && <View style={styles.toggle}>
        {streaming && <Icon name="spinner" size={12} color={colors.text_color_secondary} />}
        <Text size="xs" color="secondary">{streaming ? 'Generating...' : expanded ? 'Collapse' : 'Expand'}</Text>
        {!streaming && <Icon name={expanded ? 'chevron-up' : 'chevron-down'} size={12} color={colors.text_color_secondary} />}
      </View>}
    </Header>
    {children}
  </View>;
}
